module.exports = __webpack_public_path__ + "img/portrait-avatar-after.81c9beee.jpg";